import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsageStatsComponent } from './usage-stats/usage-stats.component';
import { SharedModule } from '@app/common/shared.module';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';
import { DataTableComponent } from './usage-stats/data-table/data-table.component';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MarkdownModule, MARKED_OPTIONS } from 'ngx-markdown';
import { BarChartComponent } from './usage-stats/bar-chart/bar-chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { UserStatsComponent } from './user-stats/user-stats.component';
import { DialogModule } from 'primeng/dialog';
import { PromptLibraryDialogComponent } from './prompt-library-dialog/prompt-library-dialog.component';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  declarations: [
    UsageStatsComponent,
    DataTableComponent,
    BarChartComponent,
    UserStatsComponent,
    PromptLibraryDialogComponent
    ],
  imports: [
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: {
          breaks: true,
        },
      },
    }),
    CommonModule,
    SharedModule,
    ButtonModule,
    CalendarModule,
    FormsModule,
    ProgressSpinnerModule,
    TableModule,
    ToastModule,
    DialogModule,
    DropdownModule
  ],
  exports: [UsageStatsComponent, BarChartComponent, PromptLibraryDialogComponent]
})
export class AdminModule { }
